import gql from 'graphql-tag';

/**
 * GQL Query for Dashboard Login Info
 */
const goodDataGql = gql`
  query ($id: Int!, $accountId: String!, $instId: String!) {
    user(id: $id, accountId: $accountId) {
      goodDataClaim(productName: "youvisit") {
        base64Encoded: base64_encoded
        encryptedClaims: encrypted_claim
        dashboards {
          project: project_id
          name
          dashboard: dashboard_id
        }
        loginUrl: dashboard_url
        ssoProvider: sso_provider
      }
    }
    institution: institutions(instID: $instId) {
      instGuid: inst_guid
    }
  }
`;

export default goodDataGql;
